<template>
  <b-card no-body class="mov requis col mb-0 margen-inferior">
    <b-card-header
      class="row px-md-4 pr-md-5"
      @click="visible = !visible"
      :class="visible ? null : 'collapsed'"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="identificadorColapsable"
    >
      <div class="col m-0 p-0">
        <button class="btn btn-link collapsed" type="button">
          <h4 class="col-12 col-md d-inline-block text-truncate p-2 px-md-2">{{tituloColapsable}}</h4>
        </button>
      </div>
      <span class="col-1 ml-auto text-md-right px-0 d-none d-md-inline-block when-close">
        <FontAwesomeIcon icon="plus" class="h2" />
      </span>
      <span class="col-1 ml-auto text-md-right px-0 d-none d-md-inline-block when-open">
        <FontAwesomeIcon icon="minus" class="h2" />
      </span>
    </b-card-header>
    <b-collapse :id="identificadorColapsable" v-model="visible" :accordion="identificadorAcordion">
      <b-card-body :class="classCardBody">
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faPlus, faMinus);
export default {
  name: "Colapsable",
  props: {
    tituloColapsable: { type: String },
    identificadorColapsable: { type: String },
    identificadorAcordion: { type: String },
    classCardBody: { type: String, default: "px-4" },
    subCollapsable: { type: Boolean, default: false }
  },
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      visible: false
    };
  }
};
</script>

<style>
.margen-inferior {
  margin-bottom: 1px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/generales/paginas/Colapsable.vue